import type { $Fetch } from 'ofetch';
import type { CommunicationFileGateway } from '@/application/port/out/CommunicationFileGateway';
import type { AttachmentPurpose, CommunicationAttachment, CommunicationFileReference, DownloadedFile, UploadCommunicationAttachment } from '@/domain/model/CommunicationFile';
import type { ApiResponse } from './types';
import { assertApiSuccess } from './assertApiSuccess';
import { downloadFilename } from './downloadFilename';
const resourcePaths: Record<AttachmentPurpose, { base: string; suffix: string }> = {
  MATERIAL_APOIO: { base: '/materiais-apoio', suffix: '/documento' },
  MANUAL: { base: '/manuais', suffix: '/anexo' },
  NOTICIA: { base: '/comunicacao/noticias', suffix: '/anexo' },
  FORUM_TOPICO: { base: '/forum/topicos', suffix: '/anexo' },
  FORUM_RESPOSTA: { base: '/forum/topicos/respostas', suffix: '/anexo' },
};
export class HttpCommunicationFileGateway implements CommunicationFileGateway {
  constructor(private readonly client: $Fetch) {}
  async upload(command: UploadCommunicationAttachment): Promise<CommunicationAttachment> {
    const body = new FormData(); body.append('finalidade', command.finalidade); body.append('arquivo', command.arquivo);
    const response = await this.client<ApiResponse<CommunicationAttachment>>('/api/v1/comunicacao/anexos', { method: 'POST', body });
    assertApiSuccess(response);
    return response.data;
  }
  async download(reference: CommunicationFileReference): Promise<DownloadedFile> {
    const resource = resourcePaths[reference.kind];
    const response = await this.client.raw<Blob, 'blob'>(`/api/v1${resource.base}/${encodeURIComponent(reference.id)}${resource.suffix}`, { method: 'GET', responseType: 'blob' });
    if (!response._data) throw new Error('O arquivo não foi retornado. Tente novamente.');
    return { blob: response._data, filename: downloadFilename(response.headers.get('Content-Disposition'), 'anexo') };
  }
}
